import React from 'react';
import { Button } from '../../../components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../../../components/ui/dialog';
import { Search, Package, ScanLine, Plus, X } from 'lucide-react';

export const AddArticleDialog = ({
  open, onOpenChange, selectedNodeCode,
  showQRScanner, onStartQR, onStopQR,
  searchQuery, onSearchChange, searching, searchResults,
  selectedArticle, onSelectArticle, onClearArticle,
  onConfirm
}) => (
  <Dialog open={open} onOpenChange={(o) => { if (!o) onStopQR(); onOpenChange(o); }}>
    <DialogContent className="max-w-lg bg-zinc-900 border-zinc-700 text-white">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Package className="w-5 h-5 text-emerald-400" />
          Adauga Articol in {selectedNodeCode}
        </DialogTitle>
        <DialogDescription className="text-zinc-400">Cautati articolul sau scanati codul QR</DialogDescription>
      </DialogHeader>
      <div className="space-y-4">
        <div className="flex gap-2">
          <button className={`flex-1 flex items-center justify-center gap-2 p-3 rounded-lg border transition-all text-sm ${!showQRScanner ? 'bg-blue-500/15 border-blue-500/40 text-blue-300' : 'bg-zinc-800 border-zinc-700 text-zinc-400 hover:border-zinc-600'}`}
            onClick={onStopQR} data-testid="add-article-mode-search">
            <Search className="w-4 h-4" /> Cauta Articol
          </button>
          <button className={`flex-1 flex items-center justify-center gap-2 p-3 rounded-lg border transition-all text-sm ${showQRScanner ? 'bg-orange-500/15 border-orange-500/40 text-orange-300' : 'bg-zinc-800 border-zinc-700 text-zinc-400 hover:border-zinc-600'}`}
            onClick={onStartQR} data-testid="add-article-mode-qr">
            <ScanLine className="w-4 h-4" /> Scaneaza QR
          </button>
        </div>

        {showQRScanner && (
          <div className="rounded-xl overflow-hidden border border-orange-500/30 bg-black">
            <div id="qr-reader-add-article" style={{ width: '100%' }} />
            <div className="p-2 text-center text-xs text-orange-300">Pozitionati codul QR in fata camerei</div>
          </div>
        )}

        {!showQRScanner && (
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-500" />
            <input
              className="w-full h-11 pl-10 pr-4 text-sm rounded-lg bg-zinc-800 border border-zinc-700 text-white outline-none focus:border-blue-500 transition-colors"
              placeholder="Cautati dupa cod, nume articol..."
              value={searchQuery}
              onChange={e => onSearchChange(e.target.value)}
              autoFocus
              data-testid="add-article-search"
            />
            {searching && (
              <div className="absolute right-3 top-1/2 -translate-y-1/2">
                <div className="w-4 h-4 border-2 border-blue-400 border-t-transparent rounded-full animate-spin" />
              </div>
            )}
          </div>
        )}

        {!showQRScanner && searchResults.length > 0 && !selectedArticle && (
          <div className="max-h-48 overflow-y-auto space-y-1 rounded-lg border border-zinc-700 p-1 bg-zinc-800/50">
            {searchResults.map(art => (
              <div key={art.id}
                className="flex items-center justify-between p-2.5 rounded-lg hover:bg-blue-500/10 cursor-pointer transition-colors border border-transparent hover:border-blue-500/20"
                onClick={() => onSelectArticle(art)}
                data-testid={`article-result-${art.code}`}>
                <div>
                  <p className="text-sm font-medium">{art.name}</p>
                  <p className="text-[10px] text-zinc-500 font-mono">{art.code}</p>
                </div>
                <div className="text-right text-[11px] text-zinc-500">{art.unit || 'buc'}</div>
              </div>
            ))}
          </div>
        )}

        {searchQuery.length >= 2 && searchResults.length === 0 && !searching && !selectedArticle && !showQRScanner && (
          <p className="text-center text-xs text-zinc-600 py-3">Niciun articol gasit</p>
        )}

        {selectedArticle && (
          <div className="p-4 rounded-xl border border-emerald-500/30 bg-emerald-500/5">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-emerald-500/20 flex items-center justify-center">
                <Package className="w-5 h-5 text-emerald-400" />
              </div>
              <div className="flex-1">
                <p className="font-medium text-sm">{selectedArticle.name}</p>
                <p className="text-[11px] font-mono text-zinc-400">{selectedArticle.code} &middot; {selectedArticle.unit || 'buc'}</p>
              </div>
              <button className="p-1 rounded hover:bg-zinc-700 transition-colors" onClick={onClearArticle}>
                <X className="w-4 h-4 text-zinc-500" />
              </button>
            </div>
            <p className="mt-2 text-[10px] text-zinc-500">Articolul va fi alocat pe pozitia {selectedNodeCode}. Stocul se adauga doar din Receptii.</p>
          </div>
        )}
      </div>
      <DialogFooter>
        <Button variant="ghost" className="text-zinc-400" onClick={() => { onStopQR(); onOpenChange(false); }}>Anuleaza</Button>
        <Button className="bg-emerald-600 hover:bg-emerald-700" disabled={!selectedArticle} onClick={onConfirm} data-testid="add-article-confirm">
          <Plus className="w-4 h-4 mr-1" />Aloca Articol
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
